export function PageLoader() {
  return (
    <div className="space-y-6 animate-pulse">
      <div className="h-5 w-48 rounded bg-white/5" />
      <div className="rounded-xl border border-white/5 bg-base-100 p-6">
        <div className="space-y-4">
          <div className="h-3 w-32 rounded bg-white/5" />
          <div className="h-4 w-full rounded bg-white/5" />
          <div className="h-4 w-3/4 rounded bg-white/5" />
        </div>
      </div>
      <div className="rounded-xl border border-white/5 bg-base-100 p-6">
        <div className="space-y-4">
          <div className="h-3 w-24 rounded bg-white/5" />
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="space-y-2">
                <div className="h-3 w-20 rounded bg-white/5" />
                <div className="h-6 w-16 rounded bg-white/5" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
